import Vue from 'vue'
import CookieUtils from 'utils/CookieUtils'

export default class InsiderService {
  static track(data) {
    Insider.track(data.title, [
      {
        event_name: data.name,
        event_params: {
          custom: data.params
        }
      }
    ])
  }

  static insiderObject(data) {
    window.insider_object = {
      user: {
        gdpr_optin: true,
        language: Vue.i18n.locale(),
        custom: data
      }
    }
  }

  static userLoginEvent(data) {
    const gdprSettings = CookieUtils.getCookie('gdpr_settings').split(',')
    const isWebAccepted = gdprSettings.filter((cookie) => cookie === 'web').length

    if (!isWebAccepted) return

    window.insider_object = {
      user: {
        gdpr_optin: true,
        email: data.email,
        language: Vue.i18n.locale(),
        custom: {
          membership_no: data.pinsNumber
        }
      }
    }
  }

  static insiderExists() {
    let script = document.getElementById('insider-worker')
    return script !== null
  }
}
